import { render, staticRenderFns } from "./IntersectionObserver.vue?vue&type=template&id=6a6fa164"
import script from "./IntersectionObserver.vue?vue&type=script&setup=true&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports